export default "__VITE_ASSET__DChUnS6X__"